import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {LoanApplicationSteps} from "../models/loan-application-step/loan-application-steps";
import {LoanApplicationService} from "../services/loan-application.service";
import {SharedStateService} from "../../core/services/shared-state.service";

export const loanApplicationStepGuard: CanActivateFn = (route, state) => {
  const router: Router = inject(Router);
  const loanApplicationService = inject(LoanApplicationService);
  const sharedState = inject(SharedStateService);

  for (const loanStep of Object.values(LoanApplicationSteps)) {
    if (loanStep == route.data["step"]) {
      return true;
    } else {
      if (loanStep == LoanApplicationSteps.CustomerAccount && sharedState.isCustomerLogged()) {
        continue;
      }
      if (!loanApplicationService.getApplicationStepFromStorage(loanStep)) {
        router.navigateByUrl("/");
        return false;
      }
    }
  }

  return true;
};
